import { Link } from "react-router-dom";
import { MessageCircle, Mail, MapPin } from "lucide-react";
import { SITE, NAV_LINKS, WA_MESSAGES } from "../data/site";
import { waLink } from "../lib/whatsapp";
import { useGoToSection } from "../lib/useGoToSection";
import { SocialLinks } from "./SocialLinks";

export const Footer = () => {
    const goTo = useGoToSection();
    return (
    <footer className="border-t border-brand-cream/10 bg-brand-brown-deep" data-testid="footer">
        <div className="mx-auto grid max-w-7xl gap-12 px-4 py-14 sm:grid-cols-2 sm:px-8 lg:grid-cols-4 lg:px-16">
            <div>
                <div className="inline-block rounded-2xl bg-white p-2.5">
                    <img
                        src={SITE.logoFull}
                        alt="033 Digital logo"
                        className="h-16 w-16 rounded-xl object-cover"
                        width="64"
                        height="64"
                        loading="lazy"
                    />
                </div>
                <p className="mt-5 font-display text-lg font-bold text-brand-paper">{SITE.tagline}</p>
                <p className="mt-1 font-mono text-xs uppercase tracking-[0.2em] text-brand-orange">{SITE.brandLine}</p>
                <SocialLinks className="mt-6" testid="footer-social" />
            </div>

            <div>
                <h3 className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-brand-cream/60">Contact</h3>
                <ul className="mt-5 space-y-3 text-sm">
                    <li>
                        <a
                            href={waLink(WA_MESSAGES.grow)}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-whatsapp-link"
                            className="inline-flex items-center gap-2.5 text-brand-cream/85 transition-colors duration-200 hover:text-brand-orange"
                        >
                            <MessageCircle size={15} aria-hidden="true" />
                            {SITE.whatsappDisplay}
                        </a>
                    </li>
                    <li>
                        <a
                            href={`mailto:${SITE.email}`}
                            data-testid="footer-email-link"
                            className="inline-flex items-center gap-2.5 text-brand-cream/85 transition-colors duration-200 hover:text-brand-orange"
                        >
                            <Mail size={15} aria-hidden="true" />
                            {SITE.email}
                        </a>
                    </li>
                    <li className="flex items-start gap-2.5 text-brand-cream/70">
                        <MapPin size={15} className="mt-0.5 shrink-0" aria-hidden="true" />
                        {SITE.location}
                    </li>
                </ul>
            </div>

            <div>
                <h3 className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-brand-cream/60">Explore</h3>
                <ul className="mt-5 space-y-3 text-sm">
                    {NAV_LINKS.map((l) => (
                        <li key={l.id}>
                            <button
                                type="button"
                                onClick={() => goTo(l.id)}
                                data-testid={`footer-link-${l.id}`}
                                className="text-brand-cream/85 transition-colors duration-200 hover:text-brand-orange"
                            >
                                {l.label}
                            </button>
                        </li>
                    ))}
                    <li>
                        <Link to="/blog" data-testid="footer-link-blog" className="text-brand-cream/85 transition-colors duration-200 hover:text-brand-orange">
                            Blog
                        </Link>
                    </li>
                </ul>
            </div>

            <div>
                <h3 className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-brand-cream/60">Legal</h3>
                <ul className="mt-5 space-y-3 text-sm">
                    <li>
                        <Link to="/privacy" data-testid="footer-privacy-link" className="text-brand-cream/85 transition-colors duration-200 hover:text-brand-orange">
                            Privacy Policy
                        </Link>
                    </li>
                    <li>
                        <Link to="/terms" data-testid="footer-terms-link" className="text-brand-cream/85 transition-colors duration-200 hover:text-brand-orange">
                            Terms of Service
                        </Link>
                    </li>
                    <li>
                        <Link to="/disclaimer" data-testid="footer-disclaimer-link" className="text-brand-cream/85 transition-colors duration-200 hover:text-brand-orange">
                            Disclaimer
                        </Link>
                    </li>
                </ul>
            </div>
        </div>
        <div className="border-t border-brand-cream/10">
            <div className="mx-auto flex max-w-7xl flex-col gap-2 px-4 py-6 font-mono text-xs text-brand-cream/50 sm:flex-row sm:items-center sm:justify-between sm:px-8 lg:px-16">
                <p>© 2026 {SITE.name}. All rights reserved.</p>
                <p>Made in Kolkata — {SITE.tagline}</p>
            </div>
        </div>
    </footer>
    );
};
